/**
 * Effective sales state of an event (SPEC §6.2 "Vorverkauf").
 *
 * Rules, in priority order:
 *  1. `over` — the event's calendar day (Europe/Zurich) has passed. Automatic:
 *     this is the safety net for "the website still links to the buy page",
 *     and no admin setting can re-open a past event.
 *  2. `paused` / `ended` — the admin scheduled a stop (`salesEndMode`) and
 *     `salesEndAt` has been reached. A stop scheduled in the future leaves
 *     sales `open` until that instant.
 *  3. `open` otherwise.
 *
 * The `active` flag is deliberately not part of this — it means "not yet
 * published" and keeps its own handling.
 */
const ZURICH_DAY = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Europe/Zurich",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
});
export function computeSalesStatus(event, now = new Date()) {
    if (ZURICH_DAY.format(now) > event.eventDate)
        return "over";
    const mode = event.salesEndMode ?? null;
    if (mode) {
        const endAt = event.salesEndAt ?? null;
        // A mode without a timestamp shouldn't exist (schema pairs them), but if
        // it does, honour the admin's intent and treat it as stopped now.
        if (endAt === null || now.getTime() >= Date.parse(endAt))
            return mode;
    }
    return "open";
}
//# sourceMappingURL=sales.js.map